<template>
  <div>
    <sb-close-button v-show="buttonChat"></sb-close-button>

    <div class="widget_body">

      <div v-if="!ready" class="widget-loading">
        <div class="icon">
          <i class="spinner"></i>
        </div>
      </div>

      <div class="widget-header color-theme-default">
        <div class="widget-header-content">

          <div class="back-to-list cvs-details" @click="goToConvoList" v-if="totalConvo > 0">
            <div class="new-message-number" v-show="totalUnseenConvos > 0">{{ totalUnseenConvos > 9 ? `9+` : totalUnseenConvos }}</div>
            <i class="backto-list-icon back"></i>
          </div>
          <div class="avatar-group agent-profile" v-if="joinedAgents.length && totalMessageSent > 1">
            <div class="agent-joined" v-for="(agent, index) in joinedAgents" :key="agent.id" v-if="index < 2">
              <div class="avatar">
                <img :src="(agent.avatar_url || defaultAvatar) | absURL">
              </div>
              <div class="info">
                <p>{{agent.fullname || '' | truncate(10)}}</p>
              </div>
            </div>
            <div class="agent-joined" v-if="joinedAgents.length > 2">
              <div class="avatar">
                <img :src="defaultAvatar | absURL">
                <div class="avatar-more-bg">
                  +{{joinedAgents.length - 2}}
                </div>
              </div>
              <div class="info">
                <p v-for="(agent, index) in joinedAgents" :key="agent.id" v-if="index >= 2">{{agent.fullname}}</p>
              </div>
            </div>
            <div class="agent-profile-intro">
              <div class="agent-profile-name">{{concatAgentsName(joinedAgents)}}</div>
            </div>
          </div>

          <div class="widget-header-title" :title="hasCustomTitle ? $t('widget_title') : account.name || $t('widget_title')" v-else>{{ hasCustomTitle ? $t('widget_title') : account.name || $t('widget_title') }}</div>

          <sb-setting @formContact="(isOpen) => {openContactForm = isOpen }"></sb-setting>
        </div>
        <sb-account-profile v-if="totalMessageSent < 2"></sb-account-profile>
      </div>

      <div class="conversation" :style="eventListStyle" :class="{'disable-conversation': openContactForm}">

        <div :class="[loading ? 'visible' : 'invisible']" class="load-more top">
          <i class="spinner"></i>
        </div>

        <div class="conversationin" ref="eventList" @scroll="onScroll">
          <div class="conversation-blank" v-show="isBlankConvo">
            <div class="blank-emotion">
              <div class="icon">
                <div class="icon-smile color-theme-default"></div>
              </div>
              <p>{{$t('start_convo')}}</p>
            </div>
            <div class="blank-arrow color-theme-default"></div>
          </div>
          <template v-for="event in events">

            <template v-if="event.senderType == 'system'">
              <div class="conversation-time" v-for="messages in event.messages">
                <template v-if="messages.sender_type === 'agent'">
                  <div class="avatar" v-for="(message, k) in messages.data" v-if="k < 3">
                    <img :src="message.avatar_url || defaultAvatar">
                    <div class="avatar-view-more" v-if="k == 2 && messages.data.length > 2">+{{messages.data.length - 2}}</div>
                    <p v-if="k < 2">
                      {{((messages.data[k] && messages.data[k].fullname) || '') | truncate(20)}}
                      {{ messages.data.length  > 2 ?` ${$t('and')} ${messages.data.length  - 2} ${$t('others')}`: ''}}</p>
                    <p v-else>{{(message.fullname || '') | truncate(20)}}</p>
                  </div>
                </template>
                <template v-else>
                  {{messages.data || ''}}
                </template>
                <span v-if="messages.type === 'joined'" :title="dateFormatTime(event.created)">{{$t('joined_the_conversation')}}</span>
                <span v-else-if="messages.type === 'left'" :title="dateFormatTime(event.created)">{{$t('left_this_conversation')}}</span>
                <span v-else-if="messages.type === 'ended'" :title="dateFormatTime(event.created)">{{$t('ended_this_conversation')}}</span>
              </div>
            </template>

            <template v-else>
              <!-- <div class="conversation-time" v-if="event.showTimeline">{{dateFormatTime(event.created)}}
              </div> -->

              <template v-for="(message, index) in event.messages">

                <template v-if="message.type == 'text'">
                  <div class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">

                        <sb-text
                          :format="message.format"
                          :text="message.data"
                          :created="event.created"
                          :senderType="event.senderType">
                        </sb-text>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'button'">
                  <div class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-button
                        :buttons="message.data"
                        v-if="event.senderType === 'agent' && message.data">
                        </sb-button>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'image'">
                  <div v-for="image in message.data" :key="`${image.url}-${event.id}`" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user', 'send-image']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-image :image="image" :senderType="event.senderType" @loaded="scrollToBottom"></sb-image>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'audio'">
                  <div v-for="audio in message.data" :key="`${audio.url}-${event.id}`" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user', 'send-audio']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-audio :audio="audio" :senderType="event.senderType"></sb-audio>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'file'">
                  <div v-for="file in message.data" :key="`${file.url}-${event.id}`" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-file :file="file" :senderType="event.senderType"></sb-file>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'video'">
                  <div v-for="video in message.data" :key="`${video.url}-${event.id}`" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user', 'send-video']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-video :video="video" :senderType="event.senderType"></sb-video>

                        <div v-if="event.senderType == 'user' && event.isLastMessage && event.seenMembers.length > 0 && index == event.messages.length - 1" class="message-status seen">
                          <img v-for="agent in event.seenMembers" :src="(agent.avatar_url || defaultAvatar) | absURL" :title="agent.fullname || ''" class="small-avatar">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'generic' && event.senderType === 'agent'">
                  <div class="messages-item messages-item-agent" v-for="generic in message.data">
                    <div class="messages-item-inner message-button">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>
                      <div class="message-content" :event_id="event.id">
                        <div class="message-body">
                          <sb-generic :generics="generic"></sb-generic>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type == 'content' && event.senderType === 'agent'">
                  <div class="messages-item messages-item-agent" v-for="content in message.data">
                    <div class="messages-item-inner message-button">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>
                      <div class="message-content" :event_id="event.id">
                        <div class="message-body">
                          <sb-content :contents="content"></sb-content>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type === 'question'">
                  <div v-for="askInfo in message.data" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-ask-info v-if="message.type === 'question'" :askInfo="askInfo" :messageId="event.id" :answered="answered[event.id]"></sb-ask-info>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="message.type === 'capture-lead' && !answered[event.id]">
                  <div v-for="askInfo in message.data" class="messages-item"
                    :class="[event.senderType == 'agent' ? 'messages-item-agent' : 'messages-item-user']">
                    <div class="messages-item-inner">
                      <div class="messages-item-avatar" v-if="event.senderType == 'agent' && event.isStart && index == 0">
                        <div class="avatar">
                          <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                        </div>
                      </div>

                      <div class="message-content" :event_id="event.id">
                        <sb-capture-lead v-if="message.type === 'capture-lead'" :attachments="askInfo" :messageId="event.id" :passed="answered[event.id]"></sb-capture-lead>
                      </div>
                    </div>
                  </div>
                </template>

              </template>

            </template>
          <div class="messages-item messages-item-agent" v-show="isOffline && event.senderType === 'agent' && event.type === 'conversation_typing'">
              <div class="messages-item-inner">
                <div class="messages-item-avatar" v-if="event.agent.id">
                  <div class="avatar">
                    <img :src="(event.agent.avatar_url || defaultAvatar) | absURL" :title="event.agent.fullname || ''">
                  </div>
                </div>

                <div class="message-content">
                  <div class="message-body color-theme-default">
                    <div id="typing">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="messages-item messages-item-user" v-show="messageSending">
            <div class="messages-item-inner">
              <div class="message-content">
                <div class="message-body"><i style="margin-left: 0;" class="spinner"></i></div>
              </div>
            </div>
          </div>

        </div>
        <div class="messages-item messages-item-agent agent-typing" v-show="agentTyping.id">
          <div class="messages-item-inner">
            <!-- {{agentTyping}} -->
            <!-- {{lastEvent}} -->
            <div class="messages-item-avatar" v-if="agentTyping.type === 'agent'">
              <div class="avatar">
                <img :src="(agentTyping.avatar_url || defaultAvatar) | absURL" :title="agentTyping.fullname || ''">
              </div>
            </div>

            <div class="message-content">
              <div class="message-body color-theme-default">
                <div id="typing">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="button-quick-replies" v-if="quickReply.id">
          <sb-quick-replies :quickReplies="quickReply.list" :eventId="quickReply.id" :convoId="convoId"></sb-quick-replies>
        </div>

        <div class="quick-move bottom unread"
          v-if="totalUnseenMessage > 0 && distanceScrollBottom > 100"
          @click.prevent="scrollToBottom()">
          {{$t('new_message')}}<v-icon name="angle-down" class="icon-angle-down" />
        </div>

      </div>
      <div :class="{'blank': isBlankConvo }">
        <sb-message-input ref="message_input" :isBlankConvo="isBlankConvo" :blockInputMessage="captureBlockInputMessage"></sb-message-input>
      </div>
      <div class="list-conversation-bottom" v-show="isEndedConvo && ready" style="z-index: 10">
        <a @click="newConvo" href="javascript:void(0)" class="button color-theme-default add-new-conversation">
          <span class="icon-plus"></span> {{ $t("new_conversation") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Setting from '../components/Setting.vue'
import MessageInput from '../components/MessageInput.vue'
import CloseButton from '../components/CloseButton.vue'
import AccountProfile from '../components/AccountProfile.vue'
import * as utils from '../utils'
import { mapGetters, mapState } from 'vuex'
import * as types from '../store/mutation_types'
import eventHub from '../lib/hub'
import Text from '../components/TextMessage.vue'
import Button from '../components/Button.vue'
import Image from '../components/ImageMessage.vue'
import Audio from '../components/AudioMessage.vue'
import File from '../components/FileMessage.vue'
import Video from '../components/VideoMessage.vue'
import AskInfo from '../components/AskInfo.vue'
import CaptureLead from '../components/CaptureLead.vue'
import Content from '../components/Content.vue'
import Generic from '../components/GenericTemplate.vue'
import QuickReplies from '../components/QuickReplies.vue'
import { u as umbrella } from 'umbrellajs'
import bowser from 'bowser'
import store from '../store'
import storage from '../lib/storage'
const objectPath = require('object-path')
const compact = require('lodash/compact')

export default {
  name: 'convo',

  components: {
    'sb-setting': Setting,
    'sb-message-input': MessageInput,
    'sb-close-button': CloseButton,
    'sb-account-profile': AccountProfile,
    'sb-text': Text,
    'sb-image': Image,
    'sb-audio': Audio,
    'sb-file': File,
    'sb-video': Video,
    'sb-ask-info': AskInfo,
    'sb-capture-lead': CaptureLead,
    'sb-button': Button,
    'sb-content': Content,
    'sb-generic': Generic,
    'sb-quick-replies': QuickReplies
  },

  data () {
    return {
      eventListStyle: {
        height: '',
        top: ''
      },
      distanceScrollBottom: 0,
      bodyStyleOfClient: { overflow: '', position: '' },
      scrollTopOfClient: 0,

      agentTyping: {},
      messageSending: false,
      bottom: false,
      pendingSeenEventIds: {},
      top: false,
      loading: false,
      convoDataReady: false,

      answered: {},
      captureBlockInputMessage: false,
      buttonChat: true,
      quickReply: {},
      joinedAgents: [],
      openContactForm: false,
    }
  },

  computed: {
    ...mapState([
      'conversations',
      'convoEvents',
      'user',
      'account',
      'agents',
      'userId',
      'accountId',
      'settingReady',
      'cssReady',
      'languageReady',
      'userReady',
      'eventEnds',
      'defaultAvatar',
      'windowMode',
			'eventLimit',
      'isHovering',
      'focusMessageinput',
      'isOffline',
      'hasCustomTitle'
    ]),

    ...mapGetters([
      'seenEventIds',
      'getConvoById',
      'countUnseenMessageByConvoId',
      'convoIds',
      'countUnseenConvos',
      'messagesSentByConvoId'
    ]),

    totalMessageSent () {
      return this.messagesSentByConvoId(this.convoId).length
    },

    totalUnseenConvos () {
      return this.countUnseenConvos(this.convoId)
    },

    totalUnseenMessage () {
      return this.countUnseenMessageByConvoId(this.convoId)
    },

    isEndedConvo () {
      const convoId = this.$route.params.convoId || ''
      const convo = store.getters.getConvoById(convoId)
      if (convo && convo.id) {
        if (convo.state === 'ended') {
          return true
        }
      }

      return false
    },

    isBlankConvo () {
      return this.events.length < 1
    },

    events () {
      const _this = this
			this.quickReply = {}
      let result = []

      const convoId = this.convoId
      const convo = this.convo

      if (!convo || !convo.id) {
        return result
      }

      let events = objectPath.get(this.convoEvents, convoId, [])
      events = utils.orderBy(events, 'created', 'asc')

      events = this.combineJoinedEvents(events)
      utils.log('[convo] events', events)

      let i = 0

      const userMessageIndexes = []
      const agentMessageIndexes = []

      events.forEach(event => {
        if (!event.id) {
          return false
        }

        const message = objectPath.get(event, 'data.message', {})
        const byId = objectPath.get(event, 'by.id', '')
        const displayId = objectPath.get(event, 'by.display_id', '')
        const senderType = _this.getSenderType(byId, convo.members)
        const item = {
          id: event.id,
          type: event.type,
          senderType,
          agent: senderType === 'agent' ? _this.getAgent(displayId || byId) : {},
          user: _this.user,
          messages: [],
          isStart: false,
          showTimeline: false,
          isLastMessage: false,
          seenMembers: [],
          created: utils.getMs(event.created)
        }

        let text = message.text || ''
        let format = message.format || 'plaintext'
        const images = []
        const videos = []
        const audios = []
        const files = []
        const generics = []
        const previews = []
        let buttons = []
        const contents = []
        const quickReplies = []
        const asks = []
        const captureLead = []

        if (event.type === 'conversation_state_updated') {
          item.senderType = 'system'

          const state = objectPath.get(event, 'data.conversation.state', '')
          if (state === 'ended') {
            if (senderType === 'agent') {
              text = [objectPath.get(item, 'agent', {})]
            } else if (senderType === 'user') {
              text = this.$t('you')
            } else {
              text = this.$t('system_ended_conversation')
            }

            item.messages.push({ type: 'ended', data: text, sender_type: senderType })
            result[i] = item
            i++
          }
        } else if (event.type === 'conversation_joined') {
          const members = objectPath.get(event, 'data.conversation.members', [])
          const agents = utils.excludeBots(_this.getAgentsFromMembers(members))

          if (!utils.isEmpty(agents)) {
            item.messages.push({ type: 'joined', data: agents, sender_type: 'agent' })
            item.senderType = 'system'
            this.joinedAgents = utils.unionBy(this.joinedAgents, agents, 'id')
            result[i] = item
            i++
          }
        } else if (event.type === 'conversation_left') {
          item.senderType = 'system'

          const members = objectPath.get(event, 'data.conversation.members', [])
          const agents = utils.excludeBots(_this.getAgentsFromMembers(members))

          if (!utils.isEmpty(agents)) {
            item.messages.push({ type: 'left', data: agents, sender_type: 'agent' })
            item.senderType = 'system'

            result[i] = item
            i++
          }
			  } else if (event.type === 'conversation_typing') {
          item.senderType = 'agent'

          result[i] = item
          i++
        } else if (event.type === 'message_sent') {
          let seenMembers = []
          let pongs = objectPath.get(event, 'data.message.pongs', [])
          pongs.forEach(pong => {
            if (pong.type === 'seen') seenMembers.push({ member_id: pong.member_id })
          })

          seenMembers = utils.unionBy(seenMembers, [], 'member_id')
          item.seenMembers = _this.getAgentsFromMembers(seenMembers)

          const attachments = objectPath.get(message, 'attachments', [])

          for (const attachment of attachments) {
            const type = attachment.type
            if (type === 'file') {
              const mimetype = attachment.mimetype

              if (mimetype === 'image/jpeg' ||
                mimetype === 'image/gif' ||
                mimetype === 'image/png') {
                images.push(attachment)
              } else if (mimetype === 'video/mp4') {
                videos.push(attachment)
              } else if (mimetype === 'audio/mpeg' || mimetype === 'audio/mp3') {
                audios.push(attachment)
              } else {
                files.push(attachment)
              }
            } else if (type === 'generic') {
              generics.push(attachment.elements)
            } else if (type === 'quick_replies') {
              quickReplies.push(attachment.quick_replies)
              this.quickReply = {id: event.id, list: attachment.quick_replies}
              this.markAsSeen(event)
            } else if (type === 'content_template') {
              contents.push(attachment.contents)
            } else if (type === 'preview') {
              previews.push(attachment)
            } else if (type === 'button') {
              buttons = attachment.buttons
            } else if (type === 'ask_info_form') {
              asks.push(attachment)
              // utils.log('attachment', attachment)

              if (objectPath.get(attachment, 'ask_info.answer', '')) {
                _this.answered[event.id] = true
              }
            } else if (type === 'form') {
              _this.answered[event.id] = false
              let requireFinished = JSON.parse(objectPath.get(attachment, 'form.state', false))
              requireFinished = objectPath.get(requireFinished, 'require_finished', '')
              let userAttribute = objectPath.get(this.user, 'attributes', [])
              let answerList = utils.cloneDeep(objectPath.get(attachment, 'form.fields', []))
              let notAnsewer = []
              let finishedQuestion = []
              answerList.forEach((item, index) => {
                let requireAttribute = JSON.parse(item.state)
                requireAttribute = objectPath.get(requireAttribute, 'require', false)
                let answer = objectPath.get(item, 'answered', '')
                if (!answer) {
                  if (requireAttribute && requireFinished) {
                    this.captureBlockInputMessage = true
                    if (objectPath.get(_this.$refs, 'message_input', '')) {
                      _this.$refs.message_input.activeInputMessage(true)
                    }
                  }
                  let findAttributeExits = userAttribute.find(attribute => attribute.key === item.name)
                  if (!objectPath.get(findAttributeExits, 'key', '') || utils.isAttributeEmpty(findAttributeExits)) {
                    notAnsewer.push(item)
                  }
                } else {
                  finishedQuestion.push(item)
                }
              })
              if (notAnsewer.length === 0) {
                if (objectPath.get(_this.$refs, 'message_input', '')) {
                  _this.$refs.message_input.activeInputMessage(false)
                }
                this.captureBlockInputMessage = false
                _this.answered[event.id] = true
                attachment.form.fields = finishedQuestion
              } else {
                attachment.form.fields = notAnsewer
              }
              captureLead.push(attachment)
            }
          }
          if (text) {
            item.messages.push({ type: 'text', data: text, format })
          }

          if (buttons.length > 0) {
            item.messages.push({ type: 'button', data: buttons })
          }

          if (images.length > 0) {
            item.messages.push({ type: 'image', data: images })
          }

          if (videos.length > 0) {
            item.messages.push({ type: 'video', data: videos })
          }

          if (audios.length > 0) {
            item.messages.push({ type: 'audio', data: audios })
          }

          if (files.length > 0) {
            item.messages.push({ type: 'file', data: files })
          }

          if (generics.length > 0) {
            item.messages.push({ type: 'generic', data: generics })
          }

          if (contents.length > 0) {
            item.messages.push({ type: 'content', data: contents })
          }

          if (quickReplies.length > 0) {
            item.messages.push({ type: 'quick-replies', data: quickReplies })
          }

          if (previews.length > 0) {
            item.messages.push({ type: 'preview', data: previews })
          }

          if (asks.length > 0) {
            item.messages.push({ type: 'question', data: asks })
          }

          if (captureLead.length > 0) {
            item.messages.push({ type: 'capture-lead', data: captureLead })
          }

          if (item.messages.length > 0) {
            if (senderType === 'user') {
              userMessageIndexes.push(i)
            } else if (senderType === 'agent') {
              agentMessageIndexes.push({
                agentId: objectPath.get(item, 'agent.id', ''),
                index: i
              })
            }
            result[i] = item
            i++
          }
        }
      })

      for (let i = 0; i <= userMessageIndexes.length - 1; i++) {
        const index = userMessageIndexes[i]
        const prevIndex = userMessageIndexes[i - 1]
        let timeSpacingUser = false
        if (index) {
          timeSpacingUser = result[index].created - result[index - 1].created > 1000 * 300
        }

        if (prevIndex === undefined || (index - prevIndex !== 1 && timeSpacingUser)) {
          result[index].showTimeline = true
        }

        if (prevIndex === undefined || index - prevIndex !== 1) {
          result[index].isStart = true
        }
      }

      if (userMessageIndexes.length > 0) {
        result[userMessageIndexes[userMessageIndexes.length - 1]].isLastMessage = true
      }

      for (let i = 0; i <= agentMessageIndexes.length - 1; i++) {
        const current = agentMessageIndexes[i] || {}
        const prev = agentMessageIndexes[i - 1] || {}
        let timeSpacingAgent = false

        if (current.index) {
          timeSpacingAgent = result[current.index].created - result[current.index - 1].created > 1000 * 300
        }

        if (!prev.index === undefined ||
          (current.index - prev.index !== 1 && timeSpacingAgent) ||
          (current.agentId !== prev.agentId && timeSpacingAgent)) {
          result[current.index].showTimeline = true
        }

        if (!prev.index === undefined ||
          current.index - prev.index !== 1 ||
          current.agentId !== prev.agentId) {
          result[current.index].isStart = true
        }
      }

      // result = utils.orderBy(result, 'created', 'asc')
			this.resizeConvoHeight()
      utils.log('[convo] result', result)
      return result
    },

    lastEvent () {
      return this.events[this.events.length - 1] || {}
    },

    ended () {
      return objectPath.get(this.eventEnds, this.convoId, false)
    },

    convoId () {
      return this.$route.params.convoId || ''
    },

    convo () {
      return this.getConvoById(this.convoId)
    },

    hasAgent () {
      return this.joinedAgents.length > 0
    },

    // joinedAgents () {
    //   const convo = this.convo
    //   if (!convo || !convo.id) return []
    //   const agents = []
    //   let members = utils.excludeBots(this.getAgentsFromMembers(convo.members))
    //   for (const member of members) {
    //     const agent = utils.find(this.agents, item => item.id === member.id)
    //     if (agent) agents.push(agent)
    //   }

    //   return agents
    // },

    totalConvo () {
      return this.conversations.length
    },

    ready () {
      utils.log('[convo - ready] accountId', this.accountId)
      utils.log('[convo - ready] userReady', this.userReady)
      utils.log('[convo - ready] cssReady', this.cssReady)
      utils.log('[convo - ready] languageReady', this.languageReady)
      utils.log('[convo - ready] settingReady', this.settingReady)
      utils.log('[convo - ready] convoDataReady', this.convoDataReady)

      const ready = this.userReady &&
        this.cssReady &&
        this.languageReady &&
        this.settingReady &&
        this.convoDataReady

      return ready
    }
  },

  async mounted () {
	      eventHub.$emit('widget.ui_changed', 'convo844' )
    // if (bowser.mobile) {
    //   let body = objectPath.get(document.getElementsByTagName('body'), '0')
    //   let html = objectPath.get(document.getElementsByTagName('html'), '0')
    //   let bodyElement = document.scrollingElement || document.documentElement

    //   this.bodyStyleOfClient.overflow = body.style.overflow || ''
    //   this.bodyStyleOfClient.position = body.style.position || ''
    //   this.scrollTopOfClient = bodyElement.scrollTop
    //   body.style.position = 'fixed'
    //   body.style.overflow = 'hidden'
    // }
    eventHub.$on('widget.hide_close_button', () => {
      utils.log('event: hide_close_button')
      this.buttonChat = false
    })

    eventHub.$on('widget.show_close_button', () => {
      utils.log('event: show_close_button')
      this.buttonChat = true
    })
    utils.log('convo mounted')

    const _this = this

    eventHub.childWindow.addEventListener('resize', this.resizeConvoHeight, false)

    const convoId = this.convoId
    const accountId = this.account.id
    let convoIds = this.convoIds

    // convo not found in store
    if (convoId && !convoIds[convoId]) {
      utils.log('convo not found in store -> fetch data convo id: ' + JSON.stringify(convoId))

      const convo = await store.dispatch('getConvo', { accountId, convoId })
      utils.log('convo response', convo)

      // convoIds không tự động nhận giá trị mới --> gán lại
      convoIds = this.convoIds
    }

    this.scrollToBottom()
    this.convoDataReady = true

    // clear if convo id not exist
    if (convoId && !convoIds[convoId]) {
      utils.log('convo not exist')
      this.removeLastConvoId()
      this.$router.push({ name: 'convo' })
    } else if (convoId && convoId !== 'id-convo-demo') {
      this.setLastConvoId(convoId)
    }

    eventHub.$on('widget.message_sent', this.handleWidgetMessageSent)
    eventHub.$on('widget.message_sending', this.handleMessageSending)
    eventHub.$on('conversation_typing', this.handleConversationMemberTyping)
    eventHub.$on('message_sent', this.handleMessageSent)

    eventHub.$on('quick_replies', text => {
      if (!objectPath.get(this.$refs, 'message_input', '')) return false
      this.$refs.message_input.submitMessage(text)
    })

    this.$on('answer', async (data) => {
      let events = this.convoEvents[this.convoId] || []
      let event = events.find(e => e.id === data.messageId)
      if (!event) return
      let attachments = objectPath.get(event, 'data.message.attachments', [])
      let index = attachments.findIndex(atb => atb.type === 'form')

      const userData = {}
      if (data.action === 'capture-lead') {
        let answeredEvent = await _this.sendCaptureLeadAnswer(data.messageId, data.answer)
        if (!answeredEvent.id || index < 0) return

        let answeredAttachments = objectPath.get(answeredEvent, 'data.message.attachments', [])
        for(const attachment in answeredAttachments){
          let fields = objectPath.get(attachment, 'form_submit.fields', [])
          let eventId = objectPath.get(attachment, 'form_submit.form_message_id', '')
          if (attachment.type === 'form_submit' && eventId === data.messageId) {
            event = utils.cloneDeep(event)
            event.data.message.attachments[index] = fields
            store.commit(types.UPDATE_EVENT, { convoId: this.convoId, event})
          }
        }
        if (objectPath.get(this.$refs, 'message_input', '')) {
          this.$refs.message_input.activeInputMessage(false)
        }
        userData.attributes = []
        data.answer.forEach(atb => {
          let state = JSON.parse(atb.state)
          if (atb.answer) {
            if (state.type === 'list') {
              userData.attributes.push({ key: atb.name, list: JSON.parse(atb.answer) })
            } else if (state.type === 'boolean') {
              userData.attributes.push({ key: atb.name, boolean: JSON.parse(atb.answer) })
            } else if (state.type === 'datetime') {
              userData.attributes.push({ key: atb.name, datetime: JSON.parse(atb.answer) })
            } else if (state.type === 'number') {
              userData.attributes.push({ key: atb.name, number: JSON.parse(atb.answer) })
            } else {
              userData.attributes.push({ key: atb.name, text: JSON.parse(atb.answer) })
            }
          }
        })
        if (utils.size(userData) > 0) {
          setTimeout(() => {
            store.commit(types.UPDATE_USER, userData)
          }, 2000)
        }
      } else {
        await _this.sendAskInfoAnswer(data.messageId, data.answer)
        _this.answered[data.messageId] = true

        const field = objectPath.get(data, 'askInfo.ask_info.key', '')

        if (field === 'user.emails') {
          userData.attributes = [{ key: 'emails', text: data.answer }]
        }
        if (utils.size(userData) > 0) {
          store.commit(types.UPDATE_USER, userData)
          await store.dispatch('updateUser', {
            accountId: this.accountId,
            userId: this.userId,
            data: userData
          })
        }
      }
    })

    umbrella(this.$el).find('.conversationin img').each((img, i) => {
      umbrella(img).on('load', _this.scrollToBottom)
    })
  },

  beforeDestroy () {
    // if (bowser.mobile) {
    //   let body = objectPath.get(document.getElementsByTagName('body'), '0')
    //   let bodyElement = document.scrollingElement || document.documentElement
    //   if (this.bodyStyleOfClient.position) {
    //     body.style.position = this.bodyStyleOfClient.position
    //   } else {
    //     body.style.removeProperty('position')
    //   }
    //   if (this.bodyStyleOfClient.overflow) {
    //     body.style.overflow = this.bodyStyleOfClient.overflow
    //   } else {
    //     body.style.removeProperty('overflow')
    //   }
    //   bodyElement.scrollTop = this.scrollTopOfClient
    // }

    eventHub.childWindow.removeEventListener('resize', this.resizeConvoHeight, false)

    eventHub.$off('widget.message_sent', this.handleWidgetMessageSent)
    eventHub.$off('widget.message_sending', this.handleMessageSending)
    eventHub.$off('conversation_typing', this.handleConversationMemberTyping)
    eventHub.$off('message_sent', this.handleMessageSent)
  },

  methods: {
    concatAgentsName (agents = []) {
      let name = ''
      agents.forEach(a => {
        if (!a.fullname) return
        name = name + a.fullname + ', '
      })
      return name.slice(0, name.length - 2);
    },

    dateFormatTime (time) {
      return utils.showDateTime(time, store.state.dateFormat)
    },

    async newConvo () {
      this.$refs.message_input.activeInputMessage(false)
      this.$router.push({ name: 'convo' })
    },

    goToConvoList () {
      this.$router.push({ name: 'convo-list' })
    },

    resizeConvoHeight: utils.throttle(function () {
      utils.log('resize Convo Height')

      this.$nextTick(function () {
        const windowMode = this.windowMode

        if (windowMode === 'mini') {
          const bodySize = umbrella('.widget_body', this.$el).size()
          const headerSize = umbrella('.widget-header', this.$el).size()
          const footerSize = umbrella('.widget-footer', this.$el).size()
          this.eventListStyle = {
            height: (bodySize.height - headerSize.height - footerSize.height) + 'px',
            top: (headerSize.height) + 'px'
          }
          return
        }

        // full or mobile
        const windowHeight = eventHub.childWindow.innerHeight
        const headerSize = umbrella('.widget-header', this.$el).size()
        const footerSize = umbrella('.widget-footer', this.$el).size()

        this.eventListStyle = {
          height: (windowHeight - headerSize.height - footerSize.height) + 'px',
          top: (headerSize.height) + 'px'
        }
      })
    }, 5),

    scrollToBottom () {
      this.distanceScrollBottom = 0
      utils.log('[convo] scroll To Bottom')

      const eventList = umbrella('.conversationin', this.$el).first()

      if (eventList) {
        utils.log('eventList.scrollHeight', eventList.scrollHeight)
        eventList.scrollTop = eventList.scrollHeight
      }
    },

    async sendAskInfoAnswer (messageId, answer) {
      const accountId = this.account.id
      let message = {
        account_id: accountId,
        type: 'message_sent',
        object: 'message',
        data: {
          message: {
            attachments: [{
              type: 'ask_info_answer',
              ask_info_answer: {
                message_id: messageId,
                answer
              }
            }]
          }
        }
      }
      await store.dispatch('sendMessage', { accountId, convoId: this.convoId, message })
    },

    sendCaptureLeadAnswer (messageId, answer) {
      const accountId = this.account.id
      const message = {
        account_id: accountId,
        type: 'message_sent',
        object: 'message',
        data: {
          message: {
            attachments: [{
              type: 'form_submit',
              form_submit: {
                state: JSON.stringify({ user_id: this.user.id }),
                form_message_id: messageId,
                fields: answer
              }
            }]
          }
        }
      }
      return store.dispatch('sendMessage', { accountId, convoId: this.convoId, message })
    },

    getSenderType (id, members) {
      const member = utils.find(members, item => item.id === id)
      // if (member) {
      if (member && member.type !== 'bot') { // bot và agent đều hiển thị giống nhau
        return member.type
      }

      const agent = utils.find(this.agents, item => item.id === id)
      if (agent) {
        return 'agent'
      }
      if (id.slice(0, 2) === 'ag') {
        return 'agent'
      }

      return 'system'
    },

    getAgent (id) {
      const agent = utils.find(this.agents, item => item.id === id)
      return agent || {}
    },

    bottomVisible () {
      const eventList = umbrella(this.$refs.eventList)

      if (!this.$refs.eventList) {
        utils.log('this.$refs.eventList not exists')
        return false
      }

      const scrollTop = this.$refs.eventList.scrollTop
      const height = eventList.size().height
      const scrollHeight = this.$refs.eventList.scrollHeight
      this.distanceScrollBottom = scrollHeight - Math.ceil(scrollTop + height)// khoảng cách scroll hiện tại đến bottom
      if (Math.ceil(scrollTop + height) >= scrollHeight) {
        return true
      }

      return false
    },

    topVisible () {
      if (!this.$refs.eventList) {
        utils.log('this.$refs.eventList not exists')
        return false
      }

      const scrollTop = this.$refs.eventList.scrollTop
      // utils.log('scrollTop', scrollTop)

      if (scrollTop <= 0) {
        return true
      }

      return false
    },

    onScroll () {
      let messages = umbrella('.message-content', this.$el)
      let scrollTop = this.$refs.eventList.scrollTop
      let heightMessages = this.eventListStyle.height.replace('px', '') * 1
      let heightHeader = this.eventListStyle.top.replace('px', '') * 1
      for (const message of messages.nodes) {
        if (!message) continue

        let distanceScrollTop = message.getBoundingClientRect().top || 0
        if (distanceScrollTop < 50 || distanceScrollTop > (heightMessages + heightHeader)) continue

        const eventId = message.getAttribute('event_id')
        const convoId = this.convoId
        const events = this.convoEvents[convoId] || []
        const foundEvent = utils.find(events, item => item.id === eventId)
        if (!foundEvent) continue

				if (this.focusMessageinput || this.isHovering) {
          this.markAsSeen(foundEvent)
        }
      }
      this.bottom = this.bottomVisible()
      this.top = this.topVisible()
    },

    delayHideTyping: utils.debounce(function () {
      this.agentTyping = {}
    }, 3000),

    async fetchEvents () {
      const accountId = this.account.id
      const convoId = this.convoId
      const limit = this.eventLimit
      await store.dispatch('getEvents', { accountId, convoId, limit })
    },

    async markAsSeen (event) {
      const convoId = this.convoId
      const convo = this.getConvoById(convoId)
      const eventId = event.id
      if (!convo || this.countUnseenMessageByConvoId(convoId) < 1) {
        return true
      }

      const userId = this.user.id
      const accountId = this.account.id

      let seen = false
      let pongs = objectPath.get(event, 'data.message.pongs', [])
      pongs.forEach(pong => {
        if (pong.type === 'seen' && pong.member_id === userId) seen = true
      })

      if (seen) return

      await store.dispatch('markAsSeenMessage', {
        accountId,
        convoId,
        messageId: eventId,
        userId
      })
    },

    async markAllAsSeen () {
      const userId = this.user.id
      const convoId = this.convoId
      const convo = this.getConvoById(convoId)
      const events = this.convoEvents[convoId] || []
      if (!convo || this.countUnseenMessageByConvoId(convoId) < 1) {
        return true
      }
      for (const event of events) {
        if (objectPath.get(event, 'by.id', '') === userId || event.type !== 'message_sent') {
          continue
        }

        let pongs = objectPath.get(event, 'data.message.pongs', [])
        let seen = false
        pongs.forEach(pong => {
          if (pong.type === 'seen' && pong.member_id === userId) seen = true
        })

        if (seen) continue

        const eventId = event.id

        // đang update seen
        if (this.pendingSeenEventIds[eventId] || this.seenEventIds[eventId]) {
          continue
        }
        if (!utils.windowIsHidden()) {
          this.pendingSeenEventIds[eventId] = true
          this.markAsSeen(event)
        }
      }
    },

    setLastConvoId (convoId) {
      store.commit(types.SET_LAST_CONVO_ID, convoId)
      storage.set('last_convo_id', convoId, 86400)
      storage.set('is_opening_convo', true, 86400)
    },

    removeLastConvoId () {
      store.commit(types.SET_LAST_CONVO_ID, '')
      storage.remove('last_convo_id')
      storage.remove('is_opening_convo')
    },

    handleWidgetMessageSent () {
      this.scrollToBottom()
    },

    handleMessageSending (sending) {
      this.messageSending = sending
    },

    handleConversationMemberTyping (event) {
      const byId = objectPath.get(event, 'by.id', '')
      const displayId = objectPath.get(event, 'by.display_id', '')
      if (byId === this.userId) {
        return false
      }

      const convoId = objectPath.get(event, 'data.conversation.id', '')
      if (convoId !== this.convoId) {
        return false
      }

      this.agentTyping = this.getAgent(displayId || byId)
      this.delayHideTyping()
    },

    handleMessageSent () {
      //if (this.distanceScrollBottom < 100) {
      //  this.scrollToBottom()
      //}
      // để trigger action seen message
      this.bottom = false

      this.$nextTick(function () {
        this.onScroll()
        this.resizeConvoHeight()
      })
    },

    getAgentsFromMembers (members = []) {
      const agents = []
      for (const member of members) {
        const agent = this.getAgent(member.member_id || member.id)
        if (agent.id) agents.push(agent)
      }
      return agents
    },

    combineJoinedEvents (events) {
      let newEvents = utils.cloneDeep(events)
      let firstIndex = null
      let lastIndex = null

      for (let index in events) {
        let event = events[index]
        if (event.type !== 'conversation_joined') {
          continue
        }

        if (!firstIndex || index - lastIndex !== 1) {
          firstIndex = index
          lastIndex = index
          continue
        }

        lastIndex = index

        delete newEvents[index]

        const existMembers = objectPath.get(newEvents[firstIndex], 'data.conversation.members', [])
        const newMembers = objectPath.get(event, 'data.conversation.members', [])

        objectPath.set(newEvents[firstIndex], 'data.conversation.members', utils.unionBy(existMembers, newMembers, 'id'))
      }

      newEvents = compact(newEvents)
      return newEvents
    }
  },

  watch: {
    focusMessageinput (focusMessageinput) {
      if (focusMessageinput) this.onScroll()
    },

    isHovering (isHovering) {
      if (isHovering) this.onScroll()
    },
    async bottom (bottom) {
			if (!bottom || this.top) return // nếu chưa có thanh scroll thì k mark all unseen
      utils.log('[convo] bottom visible')
      await this.markAllAsSeen()
    },

    hasAgent (value) {
      if (value) this.resizeConvoHeight() // resize convo when agent joined
    },

    async top (top) {
      if (!top || this.loading) return false
      utils.log('[convo] top visible')

      if (this.ended) return true

      const scrollHeight = this.$refs.eventList.scrollHeight
      const scrollTop = this.$refs.eventList.scrollTop

      this.loading = true
      await this.fetchEvents()
      this.loading = false

      this.$nextTick(function () {
        const newScrollHeight = this.$refs.eventList.scrollHeight
        this.$refs.eventList.scrollTop = newScrollHeight - scrollHeight + scrollTop
      })
    },

    ready (ready) {
      if (!ready) return
      utils.log('convo ready')
       eventHub.$emit('widget.ui_changed', 'convo1382' )
      eventHub.$emit('widget.show_iframe')

      this.$nextTick(function () {
        this.resizeConvoHeight()
        this.scrollToBottom()
        this.onScroll()
      })
    },

    convoId (convoId) {
      utils.log('[convo] convo Id changed', convoId)

      if (convoId && convoId !== 'id-convo-demo') {
        this.setLastConvoId(convoId)
      } else {
        this.removeLastConvoId()
      }

      this.$nextTick(function () {
        this.resizeConvoHeight()
        this.scrollToBottom()
        this.onScroll()
      })
    }
  }
}
</script>
